export const FEEDBACKOPTIONS_INITIATE = 'FEEDBACKOPTIONS_INITIATE';
export const FEEDBACKOPTIONS_FINISHED = 'FEEDBACKOPTIONS_FINISHED';